import { gql } from '@apollo/client';

export const INSURANCE_DOCUMENT_LIST_QUERY = gql`
  query insuranceDocuments($pager: PagerInputNew!, $filters: InsuranceDocumentFilterInput) {
    insuranceDocuments(pager: $pager, filters: $filters) {
      total
      values {
        documentId
        documentNumber
        documentDate
        userId
        userName
        documentStateId
        documentStateName
        insuranceTypeId
        insuranceTypeName
        issuedById
        issuedByName
        clientId
        clientName
        chassisNumber
        vehicleName
        offerTypeId
        offerTypeName
        navigationStep
        imageUrl
        color
      }
    }
  }
`;

export const INSURANCE_DOCUMENT_LIST_TEMPLATES_QUERY = gql`
  query insuranceDocumentListTemplates {
    insuranceDocumentListTemplates {
      templateId
      templateName
      isDefault
      fields
      filters
    }
  }
`;
